var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-line',{attrs:{"datasets":_vm.basicProjectionData,"currency":_vm.activeCurrencyWithSubunit,"granularity":"month","label":"Predicted Net Worth","chart-id":"basic-projection-chart"}})}
var staticRenderFns = []

export { render, staticRenderFns }